
import { Vue, Component, Prop } from 'vue-property-decorator'
import { IOn } from '@/types'
import ClientForm from '@/components/ClientComponents/ClientForm.vue'
import Store from '@/store'

@Component({
  components: {
    ClientForm
  }
})
export default class CreateClientBtn extends Vue {
  public dialog = false

  @Prop()
  public readonly value!: any

  public async handleOpenDialog(on: IOn, event: Event) {
    Store.commit('openClient/resetState')
    if (this.$refs.formClient) {
      /* @ts-ignore */
      await this.$refs.formClient.resetForm()
    }
    on.click(event)
  }

  public onClickClose() {
    this.dialog = false
  }
}
